export function throwIfDefined(module: any | undefined, moduleName: string) {
    if (module) {
        throw new Error(
            `${moduleName} is already loaded! Import ${moduleName} only inside AppModule!\n\nIf you wanted to use some components inside this module, consider moving components to the SharedModule.`
        );
    }
}
